import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { btnUnderLine } from "../cro/styles/buttonStyles";
import { Button, Card, Col, Radio, Row } from "antd";
import { btnOutline } from "../cro/styles/cardStyles";
import { useTranslation } from "react-i18next";

export const UtilityModal = ({
  show,
  handleClose,
  utilityList,
  selectedUtility,
  setSelectedUtility,
  handleChangeUtility,
  handleConfirm,
  setActiveKey,
  usnZipcode,
  loading,
  setSelectedPlans,
}: {
  show: boolean;
  handleClose: Function;
  utilityList: any;
  selectedUtility: any;
  setSelectedUtility: Function;
  handleChangeUtility: Function;
  handleConfirm: Function;
  setActiveKey: Function;
  usnZipcode: string;
  loading: boolean;
  setSelectedPlans: Function;
}) => {
  const [defaultGasUtility, setDefaultGasUtility] = useState<any>(null);
  const [defaultElectricUtility, setDefaultElectricUtility] =
    useState<any>(null);

  const { t } = useTranslation("cro");

  const hasMultipleCommodities = utilityList && Object.keys(utilityList)?.length > 1;

  const renderProviderCard = ({
    type,
    title,
  }: {
    type: string;
    title: string;
  }) => {
    if (utilityList?.[type]?.length) {
      return (
        <Col xs={24} lg={10}>
          <Card
            style={{ minHeight: 220, margin: 0, border: "1px solid #CBD5E0" }}
          >
            <div
              style={{
                color: "#253f66",
                margin: ".75rem 0",
                fontSize: "1.2rem",
              }}
            >
              {title}
            </div>
            <Radio.Group
              value={
                type === "Gas" ? defaultGasUtility : defaultElectricUtility
              }
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
                fontWeight: 500,
              }}
              options={
                utilityList?.[type]
                  ?.map((item: { name: any; id_utility: any }) => ({
                    label: <span style={{ color: "" }}>{item.name}</span>,
                    value: item.id_utility,
                  }))
                  ?.concat(
                    hasMultipleCommodities
                      ? {
                          label:
                            type === "Electric"
                              ? t("I'm not interested in an Electricity plan")
                              : t("I'm not interested in a Natural Gas plan"),
                          value: null,
                        }
                      : []
                  ) || []
              }
              onChange={(e) => {
                if (e.target.value === null) {
                  if (type === "Gas") {
                    setDefaultGasUtility(null);
                  } else {
                    setDefaultElectricUtility(null);
                  }
                  return;
                }
                if (type === "Gas") {
                  setDefaultGasUtility(e.target.value);
                } else {
                  setDefaultElectricUtility(e.target.value);
                }
              }}
            />
          </Card>
        </Col>
      );
    }
    return null;
  };

  useEffect(() => {
    const arr = { ...utilityList };
    const keys = Object.keys(arr);
    if (keys.length > 1) {
      arr.Both = { ...utilityList };
    }
    if (arr?.Electric?.length && arr?.Electric[0]?.id_utility) {
      setDefaultElectricUtility(arr.Electric[0].id_utility);
    }
    if (arr?.Gas?.length && arr?.Gas[0]?.id_utility) {
      setDefaultGasUtility(arr.Gas[0].id_utility);
    }
  }, [utilityList]);

  const ModalContent = () => {
    if (!utilityList || !selectedUtility) return null;
    return (
      <Row
        gutter={[32, 32]}
        style={{ color: "#253f66" }}
        justify="center"
        align="top"
      >
        {utilityList?.Electric &&
          renderProviderCard({
            type: "Electric",
            title: t("Electricity providers"),
          })}
        {utilityList?.Gas &&
          renderProviderCard({
            type: "Gas",
            title: t("Natural Gas providers"),
          })}
      </Row>
    );
  };

  return (
    <Modal
      id="utility-modal"
      show={show}
      onHide={() => handleClose()}
      centered
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <span
            style={{
              fontSize: "1rem",
            }}
          >
            <span style={{ fontWeight: "400" }}>{t("Service zip code:")}</span>
            {usnZipcode}
            <button style={btnUnderLine} onClick={() => handleClose()}>
              {t("Edit")}
            </button>
          </span>
          <div style={{ margin: ".5rem 0" }}>
            {t("Select your utility provider(s)")}
          </div>
        </Modal.Title>
        <span style={{ fontSize: "1rem", fontWeight: "" }}>
          {t(
            "Please select the correct utility company that services your address"
          )}
        </span>
      </Modal.Header>
      <Modal.Body>
        <ModalContent />
      </Modal.Body>
      <Modal.Footer style={{ border: "none" }}>
        <Row justify={"end"} align={"middle"} gutter={[16, 16]}>
          <Col>
            <Button
              loading={loading}
              onClick={() => {
                if (defaultGasUtility && defaultElectricUtility === null) {
                  setActiveKey("Gas");
                  setSelectedUtility((prev: any) => ({
                    Gas: defaultGasUtility,
                  }));
                } else if (
                  defaultElectricUtility &&
                  defaultGasUtility === null
                ) {
                  setActiveKey("Electric");
                  setSelectedUtility((prev: any) => ({
                    Electric: defaultElectricUtility,
                  }));
                } else if (defaultGasUtility && defaultElectricUtility) {
                  setActiveKey("Electric");
                  setSelectedUtility((prev: any) => ({
                    Electric: defaultElectricUtility,
                    Gas: defaultGasUtility,
                  }));
                }
                setSelectedPlans([]);
                handleConfirm();
              }}
              style={btnOutline}
            >
              {t("SEE ALL PLANS")}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};
